import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
export const SANDBOX_LOCAL_STORAGE = 'CONFIG_SANDBOX';
/** The sandbox last picked for `game`, if one was stored. */
export const savedSandbox = (game: string): string | undefined => {
  const sandboxes = localStorage.getItem(SANDBOX_LOCAL_STORAGE);
  if (!sandboxes) return undefined;
  const sandboxesObject = JSON.parse(sandboxes) as {
    game: string;
    sandbox: string;
  }[];
  return sandboxesObject.find((sandbox) => sandbox.game === game)?.sandbox;
};

export const sandboxCode = (game: string): string =>
  savedSandbox(game) ?? import.meta.env.VITE_ADMIN_SANDBOX_CODE;

/**
 * Store the game and sandbox code in the local storage
 * @param game
 * @param sandbox
 */
export const storeGameSandbox = (game: string, sandbox: string) => {
  const sandboxes = localStorage.getItem(SANDBOX_LOCAL_STORAGE);
  if (sandboxes) {
    const itemObject = JSON.parse(sandboxes) as {
      game: string;
      sandbox: string;
    }[];
    const item = itemObject.find((item) => item.game === game);
    if (item) {
      item.sandbox = sandbox;
    } else {
      itemObject.push({ game, sandbox });
    }
    localStorage.setItem(SANDBOX_LOCAL_STORAGE, JSON.stringify(itemObject));
  } else {
    localStorage.setItem(
      SANDBOX_LOCAL_STORAGE,
      JSON.stringify([{ game, sandbox }]),
    );
  }
};

/** Calendar date + optional wall-clock time for ordering comparisons (never date-only when times are enabled). */
export const composeComparableDateTime = (
  calendarDate: Date,
  timeStr: string | undefined,
  includeTime: boolean,
): Date => {
  const d = new Date(calendarDate);
  if (includeTime) {
    const raw = timeStr ?? '00:00';
    const [h = 0, m = 0] = raw.split(':').map(Number);
    d.setHours(h, m, 0, 0);
  } else {
    d.setHours(0, 0, 0, 0);
  }
  return d;
};
